<template>
  <div id="car-detail">
    <div class="card flex dspl-block-sm">
      <section class="card-section vehicle-information center-text">
        <h2>{{ selectedVehicle.contract_tag }}</h2>
        <p>{{ selectedVehicle.contract_type }}</p>
        <hr class="dspl-none-sm"/>
        <p>Marca: {{ selectedVehicle.brand }}</p>
        <p>Model: {{ selectedVehicle.model }}</p>
        <p>Año: {{ selectedVehicle.year }}</p>
        <p>Caseta: {{ selectedVehicle.stall_key }}</p>
      </section>
      <hr />
      <section class="card-section grow-1">
        <div class="flex justify-space-between dspl-block-m dspl-block-sm">
          <h3> Saldo Disponible: {{ selectedVehicle.formatted_balance }} </h3>
        </div>
        <div v-if="canCreateOrder">
          <p>RECARGA DE SALDO</p>
          <BalanceForm />
        </div>
        <div v-else>
          <p>Atención: {{ selectedVehicle.last_purchase.message }}</p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BalanceForm from '@/components/Vehicle/BalanceForm'

export default {
  name: 'Balance',
  components: {
    BalanceForm
  },
  computed: {
    ...mapGetters('saleOrderForm', ['selectedVehicle']),
    canCreateOrder: function () {
      if (this.selectedVehicle.last_purchase) {
        return this.selectedVehicle.last_purchase.fulfilled
      }

      return true
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

#car-detail {
  color: $grey;
  text-align: start;
  margin: 1rem 2rem;
}

.link {
  color: $blue;
  text-decoration: none;
  font-style: italic;
}

.card {
  border-radius: 25px;
  background-color: $white;
  width: 75%;
}

.card-section {
  padding: 1.25rem 2rem;
}

.vehicle-information {
  width: 25%;
}

.center-text {
  text-align: center;
}

.btn {
  font-size: 0.75rem;
  border-radius: 20px;
  padding: 0.5rem 1.5rem;
  border: 1px solid $light-blue;
  cursor: pointer;

  &:focus {
    outline-width: 0;
  }

  &.accept {
    color: $white;
    margin-left: 1rem;
    background-color: $light-blue;
  }

  &.cancel {
    margin-right: 1rem;
    color: $light-blue;
    background-color: $white;
  }

  &:disabled {
    background-color: #8f919d;
    border: 1px solid #8f919d;
    cursor: inherit;
  }
}

hr {
  border: 1px solid $grey;
  margin-block-start: 1.25rem;
  margin-block-end: 1.25rem;
  margin-inline-start: 0;
  margin-inline-end: 0;
}
.whalf {
  width: 50%;
}

.bold {
  font-weight: bold;
}

@media screen and (max-width: 60rem) {
  .link {
    display: none;
  }

  .card {
    width: 100%;
  }

  .vehicle-information {
    width: auto;
  }

  .btn {
    &.accept {
      margin-left: 0;
    }

    &.cancel {
      margin-right: 0;
    }
  }

  h2 {
    font-size: 1.25rem;
  }

  hr {
    margin-block-start: 0rem;
    margin-block-end: 0rem;
    margin-inline-start: 1.25rem;
    margin-inline-end: 1.25rem;
  }
}
</style>
